'use client';

import { Button } from '../Button';
import { HTML } from '../Html';
import { Link } from '../Link';
import { S } from './StatusPage.styles';
import type { StatusPageProps } from './StatusPage.types';

// TODO: Consider Removing this component and using the one from smartface instead.
export const StatusPage = ({
  title,
  subtitle,
  redirectButton,
  actionButton,
  children,
  ...otherProps
}: StatusPageProps) => (
  <S.Container data-guide-id="status-page" {...otherProps}>
    <S.Content>
      {title && <S.Title data-guide-id="status-page-title">{title}</S.Title>}
      {subtitle && (
        <S.SubTitle data-guide-id="status-page-subtitle">
          <HTML html={subtitle} />
        </S.SubTitle>
      )}
      {children}
      {actionButton && (
        <S.ButtonWrapper>
          <Button data-guide-id="status-page-action-btn" onClick={actionButton.onClick}>
            {actionButton.title}
          </Button>
        </S.ButtonWrapper>
      )}
      {redirectButton && (
        <S.ButtonWrapper>
          <Link href={redirectButton.href}>
            <Button data-guide-id="status-page-redirect-btn">{redirectButton.title}</Button>
          </Link>
        </S.ButtonWrapper>
      )}
    </S.Content>
  </S.Container>
);
